import * as React from 'react';
import { Layout } from 'antd';

import { DocLayout } from 'src/layouts/DocLayout';
import { FulfillmentApiDoc } from 'src/containers/FulfillmentApiDoc';

export class FulfillmentDocPage extends React.Component {
  render() {
    return (
      <DocLayout>
        <Layout className="doc-root">
          <FulfillmentApiDoc />
        </Layout>
      </DocLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/FulfillmentDocPage/index.tsx